<script>
import Product from '@components/product'
import SubHeader from '@components/sub-header'
import CustomArrow from '@components/custom-arrow'

const DEFAULT_PRODUCT_IMAGE =
  'https://lupe.rappi.com/assets/images/default-product.png'

export default {
  name: 'ResumeProducts',
  components: {
    Product,
    SubHeader,
    CustomArrow,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openedPanel: 0,
    }
  },
  computed: {
    computedWhims() {
      return this.componentData.whims.map(w => {
        w.image = DEFAULT_PRODUCT_IMAGE
        w.product_id = this.$t('WIDGETS.PRODUCTS_WRAPPER.WHIMS')
        w.total_price = w.price
        return w
      })
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <SubHeader :text="componentData.title"/>

    <template>

      <Product
        v-for="(product) in componentData.products"
        :key="product.id"
        :product="product"
      />
    </template>
    <template v-if="computedWhims.length > 0">

      <Product
        v-for="(whim, index) in computedWhims"
        :key="index"
        :product="whim"
      />
    </template>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  padding: 1rem 0 1.2rem 0;
  margin: $size-spacing-medium 0;
  background-color: $background-container;
}
</style>
